// src/components/TestimonialsSlider.jsx
import React, { useState, useCallback } from 'react';
import './TestimonialSlider.css';

import prokhorImage from './media/11319.jpg'
import elenaImage from './media/11319.jpg'; 
import veronikaImage from './media/11319.jpg'; 

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState(0);

  const slides = [
    {
      title: "Прохор Северянский",
      subtitle: "Промпитерстрой, Началник рекламного отдела",
      text: "Платформа Динамика помогла мне понять, как взаимодействовать с сотрудниками моего отдела и наладить взаимоотношения в коллективе. Также я понял, кого можно повысить, а кем — попрощаться. Платформа удобная, что где находится разобрался сразу.",
      image: prokhorImage // используем импортированное изображение
    },
    {
      title: "Елена Силевёрстова",
      subtitle: "Невский завод Трубодеталь, Старший hr-менеджер",
      text: "Спустя три месяца после внедрения Динамики в нашу работу я могу оценить ее эффективность. За это время увольнения сотрудников сократились на 35%. Также мне стало проще подбирать новые кадры, сразу понятнее, кто именно нужен.",
      image: elenaImage // используем импортированное изображение
    },
    {
      title: "Вероника Кроль",
      subtitle: "Ситбит, Директор",
      text: "Считаю, что платформа Динамика — отличный продукт, аналогов которому пока нет. Мы приобрели доступ и не пожалели. Я теперь лучше осознаю процессы, происходящие внутри коллектива, и знаю, чем замотивировать того или иного сотрудника",
      image: veronikaImage // используем импортированное изображение
    }
  ];

  // Остальной код без изменений...
  const handleTouchStart = useCallback((e) => {
    setStartX(e.touches[0].clientX);
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!startX) return;
    
    const currentX = e.touches[0].clientX;
    const diffX = startX - currentX;

    if (Math.abs(diffX) > 50) {
      if (diffX > 0) {
        setCurrentIndex(prev => 
          prev === slides.length - 1 ? 0 : prev + 1
        );
      } else {
        setCurrentIndex(prev => 
          prev === 0 ? slides.length - 1 : prev - 1
        );
      }
      setStartX(0);
    }
  }, [startX, slides.length]);

  return (
    <>
    <h2 className="slider-title">Что говорят о нас клиенты</h2>
    <div className="slider-container">
      <div 
        className="slider"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={() => setStartX(0)}
      >
        <div className="slides-wrapper">
          {slides.map((slide, index) => (
            <div 
              key={index} 
              className={`slide ${index === currentIndex ? 'active' : ''}`}
              style={{
                transform: `translateX(${(index - currentIndex) * 300}px)`,
                zIndex: index === currentIndex ? 2 : 1
              }}
            >
              <img 
                src={slide.image} 
                alt={slide.title}
                className="circle-image"
              />
              <h3>{slide.title}</h3>
              <p className="subtitle">{slide.subtitle}</p>
              <p className="text">{slide.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default TestimonialSlider;